{
  "AGENT_MGMT": {
    "HEADER": "Ügynökök",
    "HEADER_BTN_TXT": "Ügynök Hozzádása",
    "LOADING": "Ügynökök Listájának Lekérése",
    "DESCRIPTION": "Az ügynök az ügyfélszolgálati csapat tagja, aki megtekintheti a felhasználói üzeneteket és válaszolhat rájuk. Az alábbi lista a fiók összes ügynökét mutatja.",
    "LEARN_MORE": "Tudjon meg többet a felhasználói szerepkörökről",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Adminisztrátor",
      "AGENT": "Ügynök"
    },
    "TABS": {
      "ACTIVE": "Aktív",
      "DEACTIVATED": "Deaktivált"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Telefon leválasztása",
      "API": {
        "SUCCESS_MESSAGE": "Az ügynök telefonja sikeresen leválasztva",
        "ERROR_MESSAGE": "Nem sikerült leválasztani az ügynök telefonját, kérjük, próbálja újra később"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Újraaktiválás",
      "API": {
        "SUCCESS_MESSAGE": "Az ügynök sikeresen újraaktiválva",
        "ERROR_MESSAGE": "Nem sikerült újraaktiválni az ügynököt, kérjük, próbálja újra később"
      },
      "CONFIRM": {
        "TITLE": "Újraaktiválás megerősítése",
        "MESSAGE": "Biztosan újra szeretné aktiválni a következőt: ",
        "YES": "Igen, újraaktiválás ",
        "NO": "Nem, mégse "
      }
    },
    "LIST": {
      "404": "Ehhez a fiókhoz nincs ügynök rendelve",
      "TITLE": "A csapatod ügynökeinek kezelése",
      "DESC": "Hozzáadhatsz és törölhetsz ügynököket a csapatodban.",
      "NAME": "Név",
      "EMAIL": "EMAIL",
      "STATUS": "Státusz",
      "ACTIONS": "Műveletek",
      "VERIFIED": "Megerősített",
      "VERIFICATION_PENDING": "Megerősítés függőben",
      "API_ALLOWED": "API hozzáférés engedélyezve",
      "DEACTIVATED_ON": "Deaktiválva",
      "AVAILABLE_CUSTOM_ROLE": "Elérhető egyedi szerepkör-jogosultságok"
    },
    "ADD": {
      "TITLE": "Ügynök hozzáadása a csapathoz",
      "DESC": "Olyan személyeket adhat hozzá, akik kezelni tudják majd a postafiókot.",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "FORM": {
        "NAME": {
          "LABEL": "Ügynök neve",
          "PLACEHOLDER": "Kérjük adja meg az ügynök nevét"
        },
        "AGENT_TYPE": {
          "LABEL": "Agent Type",
          "PLACEHOLDER": "Please select a type",
          "ERROR": "Agent type is required"
        },
        "EMAIL": {
          "LABEL": "Email cím",
          "PLACEHOLDER": "Kérjük adja meg az ügynök email címét"
        },
        "SUBMIT": "Ügynök Hozzádása"
      },
      "API": {
        "SUCCESS_MESSAGE": "Ügynök sikeresen hozzáadva",
        "EXIST_MESSAGE": "Az ügynök email cím már használatban van, kérjük próbálkozzon újra másik email címmel",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Törlés",
      "API": {
        "SUCCESS_MESSAGE": "Ügynök sikeresen hozzáadva",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      },
      "CONFIRM": {
        "TITLE": "Törlés megerősítése",
        "MESSAGE": "Biztos abban, hogy törli ",
        "DESCRIPTION": "Az ügynök azonnal kijelentkezik, eltávolítjuk minden csapatból és postafiókból, és a továbbiakban nem fog hozzáférni ehhez a fiókhoz.",
        "YES": "Igen, Törlés ",
        "NO": "Nem, Mégse "
      }
    },
    "EDIT": {
      "TITLE": "Ügynök szerkesztése",
      "FORM": {
        "NAME": {
          "LABEL": "Ügynök neve",
          "PLACEHOLDER": "Kérjük adja meg az ügynök nevét"
        },
        "AGENT_TYPE": {
          "LABEL": "Szerepkör",
          "PLACEHOLDER": "Válassz szerepkört",
          "ERROR": "Szerepkör megadása kötelező."
        },
        "EMAIL": {
          "LABEL": "Email cím",
          "PLACEHOLDER": "Kérjük adja meg az ügynök email címét"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Elérhetőség",
          "PLACEHOLDER": "Adj meg elérhetőség státuszt",
          "ERROR": "Elérhetőség megadása kötelező"
        },
        "API_ACCESS": {
          "LABEL": "API hozzáférés engedélyezése",
          "HELP": "Az API hozzáférés alapértelmezés szerint ki van kapcsolva. Bekapcsolása lehetővé teszi, hogy az ügynök személyes API-kulcsát használják minden fiókban, amelynek tagja. Az irányítópultba történő bejelentkezést ez nem érinti."
        },
        "SUBMIT": "Ügynök szerkesztése"
      },
      "BUTTON_TEXT": "Szerkesztés",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "API": {
        "SUCCESS_MESSAGE": "Ügynök sikeresen frissítve",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Új jelszó kérése",
        "ADMIN_SUCCESS_MESSAGE": "Egy e-mail a jelszófrissítési utasításokkal sikeresen kiküldve az ügynöknek",
        "SUCCESS_MESSAGE": "Ügynök jelszó sikeresen frissítve",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "Nincs találat."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Nincs",
      "TITLE": {
        "AGENT": "Ügynök kiválasztása",
        "TEAM": "Csapat kiválasztása"
      },
      "LIST": {
        "NONE": "Nincs"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Nem találunk ügynököt",
          "TEAM": "Nem találtunk csapatot"
        },
        "PLACEHOLDER": {
          "AGENT": "Ügynökök keresése",
          "TEAM": "Csapatok keresése",
          "INPUT": "Ügynök keresése"
        }
      }
    }
  }
}
